export default {
	title: 'Region',
	subheader: 'Manažeři v kampani',
	manager: 'Manažer',
};
